
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine",
      function () {
        return require("private-next-pages/magazine.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine"])
      });
    }
  